var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "verification" }, [
    _c("div", { staticClass: "acc-page-holder" }, [
      _vm.brandTemplate !== "generic_2" &&
      _vm.mobileBigAndBelow &&
      _vm.showMap &&
      _vm.accountSummaryFlow
        ? _c(
            "div",
            { staticClass: "account-heading" },
            [
              _c("icon", { attrs: { name: "icon-acc-verification" } }),
              _vm._v(_vm._s(_vm.$t("MyAccount.FirstTimeLogin.Title")))
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.brandTemplate === "generic_2"
        ? _c("h1", { staticClass: "ver_status" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("Account.Verification.Status.Title")) + " "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "verification-content" }, [
        !_vm.isCustomerVerified
          ? _c("div", [
              _vm.showMap
                ? _c("div", [
                    _c("div", {
                      staticClass: "blue-heading",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t(
                            "Account.SequentialVerification.GuidedVerification.Title"
                          )
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "padding-separate" },
                      [
                        _c("VerTitles", {
                          attrs: {
                            currStepTitle: _vm.$t(
                              "Account.SequentialVerification.VerificationMaps.Title"
                            ),
                            isMapPage: false
                          },
                          on: { closePage: _vm.closeVerPage }
                        }),
                        _vm._v(" "),
                        _vm.verMaps && _vm.verMaps.length > 0
                          ? _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  { staticClass: "verification_map_desc" },
                                  [
                                    _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "Account.SequentialVerification.VerificationMaps.Desc"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.verMaps &&
                                _vm.verMaps.length === 1 &&
                                _vm.verMaps[0].idtxregpage === "VERIFY_SLF" &&
                                _vm.brandKey === "generic-boyd"
                                  ? _c("div", [
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "Account.SequentialVerification.VerificationMaps.In.Casino.Desc"
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "Account.SequentialVerification.VerificationMaps.In.Casino.Desc2"
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", {
                                        staticClass: "color-red font-600",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "Account.SequentialVerification.VerificationMaps.In.Casino.Desc3"
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "Account.SequentialVerification.VerificationMaps.In.Casino.Desc4"
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "Account.SequentialVerification.VerificationMaps.In.Casino.Desc5"
                                            )
                                          )
                                        }
                                      })
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.verMaps, function(vM) {
                                  return _c("div", { key: vM.mapno }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "verification__instruments"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "verification__instruments_item sightlinec diss",
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.go2Verification(
                                                  vM.mapno
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "piitem-text" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "piitem-text-headline"
                                                  },
                                                  [_vm._v(_vm._s(vM.title))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "vm_shortdesc piitem-text-desc"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        vM.shortdescription
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "piitem-text-desc"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(vM.mapdescription)
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "piitem-arrow" },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("chevron_right")
                                                ])
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                })
                              ],
                              2
                            )
                          : _c("div", [
                              _c(
                                "div",
                                { staticClass: "verification_map_desc" },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Account.SequentialVerification.VerificationMaps.NoMaps"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ])
                      ],
                      1
                    )
                  ])
                : _c(
                    "div",
                    [
                      _c("Verification", {
                        on: { closePage: _vm.closeVerPage }
                      })
                    ],
                    1
                  )
            ])
          : _c("div", [
              _vm.brandTemplate === "generic_2"
                ? _c("div", {
                    staticClass: "blue-heading",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "Account.SequentialVerification.GuidedVerification.Title"
                        )
                      )
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "padding-separate verified_customer" },
                [
                  _vm.isEmailVerified && _vm.brandTemplate === "generic_2"
                    ? _c("div", { staticClass: "badge_verified" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.SequentialVerification.VerifyByPin.Verification.Detail.Status.Verified"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "icon-verified" })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("VerTitles", {
                    attrs: {
                      currStepTitle: _vm.$t(
                        "Account.Verification.Status.Title"
                      ),
                      isMapPage: false
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "verification_map_desc" }, [
                    _c("p", {
                      staticClass: "span_bold",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("Account.Verification.Status.Desc")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _vm.brandKey === "sb"
                      ? _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("Account.Verification.Status.Superbook")
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.brandKey !== "sb"
                      ? _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Verification.Status.PlaySportsbook"
                              )
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.brandTemplate === "generic_2" &&
                    (!_vm.isEmailVerified || !_vm.isPhoneVerified)
                      ? _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("Account.Verification.Status.Rilot")
                            )
                          }
                        })
                      : _vm._e()
                  ])
                ],
                1
              )
            ])
      ]),
      _vm._v(" "),
      _vm.showMap
        ? _c(
            "div",
            [
              _c("verify-detail", { attrs: { detail: "phone" } }),
              _vm._v(" "),
              _c("verify-detail", { attrs: { detail: "email" } })
            ],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.brandTemplate === "generic_2"
      ? _c(
          "div",
          { staticClass: "acc_page_bgr_img" },
          [_c("icon", { attrs: { name: "icon-acc-verification" } })],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8942c2f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8942c2f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Verification/VerificationMaps.vue
// module id = null
// module chunks = 